<template>
  <header class="intro">
    <div class="content-header">
      <div class="container">
        <div class="flex-itens">
          <div class="brand-headline">
            <h1 class="brand-heading">Agora você pode criar<br>conteúdo de forma<br>automática!</h1>
            <h3 class="brand-subtitle">Aqui está a melhor forma de aumentar sua presença online, sua
                autoridade e vendas, com uso inteligente do seu tempo.</h3>
            <a :href="registerLink" class="btn btn-green btn-light btn-sm mb-5">Comece Agora</a>
          </div>
          <div class="brand-manyb">
            <img class="manyb" src="@/assets/manybot.png">
          </div>
          <div class="brand-earlyadopter">
            <h1 class="title-earlyadopter">Seja um dos primeiros</h1>
            <h2 class="title-earlyadopter"><span class="badge-ganhe">Ganhe</span> 30% OFF vitalício</h2>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['registerLink'])
  }
}
</script>
